module.exports = __webpack_public_path__ + "img/cardiovascular.f67cf091.jpg";